import React, { useRef } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import Card from './card';
import useInfiniteScroll from 'hooks/useInfiniteScroll';

const PostGrid = ({ posts }) => {
  const scrollEdgeRef = useRef(null);
  const currentList = useInfiniteScroll({
    posts,
    scrollEdgeRef,
    maxPostNum: 10,
    offsetY: 200,
  });

  return (
    <Grid role="list">
      {currentList.map((data) => {
        const { id, slug, title, desc, date, category, thumbnail, alt } = data;
        const ariaLabel = `${title} - ${category} - Posted on ${date}`;
        return (
          <List key={id} role="listitem">
            <Link to={slug} aria-label={ariaLabel}>
              <Card
                thumbnail={thumbnail}
                alt={alt}
                category={category}
                title={title}
                desc={desc}
                date={date}
              />
            </Link>
          </List>
        );
      })}
      <div ref={scrollEdgeRef} />
    </Grid>
  );
};

const Grid = styled.ul`
  list-style: none;

  & > li {
    margin-bottom: var(--grid-gap-xl);
    @media (max-width: ${({ theme }) => theme.device.sm}) {
      margin-bottom: var(--grid-gap-lg);
    }
  }
`;

const List = styled.li`
  box-sizing: border-box;
  grid-column: span 1;

  a {
    display: block;
    height: 100%;
  }

  @media (max-width: ${({ theme }) => theme.device.sm}) {
    grid-column: span 2;
  }
`;

export default PostGrid;
